import { kevinAuthAPI } from 'apis/config';

export const loadingApis = {
  loadingList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/loading/${projectId}`)
      .then((res) => res.data),
  loadingCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/loading/${projectId}`, data)
      .then((res) => res.data),
  loadingUpdateImage: (projectId, id, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/loading/${projectId}/${id}/change`, data)
      .then((res) => res.data),
  loadingUpdateInfor: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/resource-manager/loading/${projectId}/${id}`, data)
      .then((res) => res.data),
  loadingDelete: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/loading/${projectId}/${id}`)
      .then((res) => res.data),
};
